import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  myFlyers: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
